<template>
	<section class="page">
		<div class="d-print-none">
			<h2>{{info.type.name}}</h2>
			<div
				class
				v-if="info.storehouse._id"
			>{{info.storehouse.name}}</div>
		</div>
		<el-tabs v-model="activeName">
			<el-tab-pane label="出入库信息" name="info">
				<div v-if="activeName=='info'" v-loading="loadings.main">
					<curd-table
						class="content-box"
						:auto-load="false"
						ref="listItemTable"
						data-model="reserve_tx_item"
						:fields="itemsTableFieldsReal"
						:list-ops="[]"
						:has-delete="false"
						:has-page="false"
						:show-summary="true"
					></curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import CurdPage from "@/mixins/CurdPage.js";
import TabPage from "@/mixins/TabPage.js";
import TxOp from "@/mixinsApp/TxOp.js";
import Outbound from "@/views/Inventory/Infos/Outbound.vue";
import Inbound from "@/views/Inventory/Infos/Inbound.vue";
import Stocktaking from "@/views/Inventory/Infos/Stocktaking.vue";
import Scheduling from "@/views/Inventory/Infos/Scheduling.vue";
import Backbound from "@/views/Inventory/Infos/Backbound.vue";
import EditInBound from "@/views/Inventory/subs/EditInbound";
import EditOutBound from "@/views/Inventory/subs/EditOutBound";
import EditStocktaking from "@/views/Inventory/subs/EditStocktaking";
import EditScheduling from "@/views/Inventory/subs/EditScheduling";

export default {
	config: {
		names: {},
	},
	mixins: [CurdPage, TabPage, TxOp],
	components: {},
	data() {
		return {
			isInfoPage: true,
			loadings: {
				main: false,
			},
			recordId: "",
			activeName: "info",
			editorVisibleRecv: false,
			info: {
				_id: "",
				type: {
					index: 0,
					name: "",
				},
				items: [],
				storehouse: {
					_id: "",
				},
				supplier: {
					_id: "",
				},
			},
			hasGetData: false,
			itemsTableFields: [
				{
					name: "brand_show_id",
				},
				{
					name: "brand",
				},
				{
					name: "product_color",
				},
				{
					name: "model",
				},
				{
					name: "storehouse",
				},
        {
          name: "warehouse",
        },
				{
					name: "price_per",
				},
				{
					name: "amount",
				},
				{
					name: "total_price",
				},
			],
		};
	},
	computed: {
		...mapState(["userPrivilegeMapping"]),
		itemsTableFieldsReal() {
			return this.itemsTableFields.filter(key => {
				if (
					(key.name == "cost_per" ||
						key.name == "price_per" ||
						key.name == "total_price") &&
					!this.userPrivilegeMapping[59]
				) {
					return false;
				}
				return true;
			});
		},
	},
	created() {},
	mounted() {
		// this.refreshRoute();
	},
	methods: {
		refreshRoute() {
			this.recordId = this.$route.params.id;
			if (this.$route.params.tab) {
				this.activeName = this.$route.params.tab;
			}
			this.refreshData();
		},
		setData(data) {
			this.info = Object.assign({}, data.info);
			if (data.tx_items) {
				this.info.items = data.tx_items;
			}

			this.$nextTick(() => {
				if (this.$refs["baseInfoTable"]) {
					this.$refs["baseInfoTable"].setData(data.info);
				}
				if (data.tx_items && this.$refs["listItemTable"]) {
					this.$refs["listItemTable"].setData(data.tx_items);
				}
			});
		},
		refreshData() {
			// debugger;
			this.loadings.main = true;
			this.$axios
				.post(`/reserve/tx_info/${this.recordId}`)
				.then(json => {
					this.loadings.main = false;
					this.setData(json.data);
					this.hasGetData = true;
				})
				.catch(json => {
					console.error(json);
					// debugger;
					this.$message.error(json.data.msg);
					this.loadings.main = false;
					this.$router.push({
						name: "Reserve-Inbound",
						params: {},
					});
				});
		},
		onSendTx() {
			this.refreshData();
		},
	},
	watch: {
		hasGetTableDataModel: {
			handler(val) {
				if (val) {
					// this._refreshRules();
				}
			},
			immediate: true,
		},
	},
};
</script>
<style lang="scss" scoped>
</style>
